<!-- eslint-disable vue/no-mutating-props -->
<template>
  <card card-body-classes="table-full-width" :title="$t('cars.addTools')" :on-cancel="cancel">
    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="col-12 col-md-4 col-sm-6 mb-2">
          <el-input
            v-model="searchQuery"
            class="search-input"
            clearable
            :prefix-icon="Search"
            :placeholder="$t('common.searchRecords')"
            aria-controls="datatables"
            @keyup="search"
            @clear="handleClearSearch"
          />
        </div>
      </div>

      <!-- Desktop Table -->
      <el-table v-if="!isMobile" :data="tools">
        <el-table-column :label="$t('common.image')">
          <template #default="{ row }">
            <img :src="'data:image/png;base64,' + row.image" class="img-fluid shadow" alt="Tool Image" />
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
        >
        </el-table-column>
        <el-table-column :min-width="100" align="right" label="">
          <template #default="{ row }">
            <i class="material-icons add-tool-icon" @click="addTool(row.id)">directions_bus</i>
          </template>
        </el-table-column>
      </el-table>

      <!-- Mobile Table -->
      <el-table v-else :data="tools">
        <el-table-column label="Image">
          <template #default="{ row }">
            <img :src="'data:image/png;base64,' + row.image" class="img-fluid shadow" alt="Tool Image" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.info')" min-width="180">
          <template #default="{ row }">
            <div>
              <div><strong>{{$t('common.name')}}:</strong> {{ row.name }}</div>
              <div><strong>{{$t('tools.brand')}}:</strong> {{ row.brand }}</div>
              <div>
                <i class="material-icons add-tool-icon" @click="addTool(row.id)">directions_bus</i>
              </div>

            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <template #footer>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap pagination">
        <div class="">
          <p class="card-category">
            {{ $t('pagination.showing') }} {{ from + 1 }} {{ $t('pagination.to') }} {{ to }} {{ $t('pagination.of') }} {{ total }} {{ $t('pagination.entries') }}
          </p>
        </div>
        <material-pagination color="info" class="pagination-no-border">
          <material-pagination-item
            prev
            :disabled="pagination.currentPage === 1"
            @click="prevPage"
          />
          <material-pagination-item
            v-for="page in displayedPages"
            :key="page"
            :label="String(page)"
            :active="pagination.currentPage === page"
            @click="changePage(page)"
          />
          <material-pagination-item
            next
            :disabled="pagination.currentPage === totalPages"
            @click="nextPage"
          />
        </material-pagination>
      </div>
    </template>
  </card>
</template>
<script>
import api from "../../services/api"
import MaterialPagination from '../../components/MaterialPagination.vue';
import MaterialPaginationItem from '../../components/MaterialPaginationItem.vue';
import { ElTable, ElTableColumn, ElInput } from 'element-plus';
import { Search } from '@element-plus/icons-vue';
import Card from "../../components/Card.vue";

export default {
  name: 'AddToolTable',
  components: {
    MaterialPagination,
    MaterialPaginationItem,
    ElTable,
    ElTableColumn,
    ElInput,
    Card
  },
  props: {
    toolGroupId: {
      type: [String, Number],
      default: null
    }
  },
  emits: ['close', 'refresh-data'],

  data() {
    return {
      Search,
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      tableColumns: [
        {
          prop: 'name',
          label: this.$t('common.name'),
          minWidth: 100
        },
        {
          prop: 'description',
          label: this.$t('common.description'),
          minWidth: 240
        },
        {
          prop: 'brandName',
          label: this.$t('tools.brand'),
          minWidth: 200
        }
      ],
      searchQuery: '',
      tools: [],
      initalPage: true,
      isMobile: window.innerWidth <= 1024
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    totalPages() {
      if (this.total > 0) {
        return Math.ceil(this.total / this.pagination.perPage);
      }
      return 1;
    },
    displayedPages() {
      const pages = [];
      const maxPages = Math.min(5, this.totalPages);

      let startPage = Math.max(1, this.pagination.currentPage - Math.floor(maxPages / 2));
      let endPage = startPage + maxPages - 1;

      if (endPage > this.totalPages) {
        endPage = this.totalPages;
        startPage = Math.max(1, endPage - maxPages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  created() {
    this.fetchToolData();
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
    search(event){
      this.pagination.currentPage = 1;
      const queryLength = this.searchQuery.length;
      if (event.key === 'Backspace' || event.key === 'Enter') {
        this.fetchToolData();
      }
      else {
        if (queryLength > 1) {
          if (queryLength % 2 === 0) {
            this.fetchToolData();
          }
        }
      }
    },
    handleClearSearch(){
      this.fetchToolData();
    },
    updatePage(item){
      this.pagination.currentPage = item;
      this.fetchToolData()
    },
    changePage(page) {
      if (page !== this.pagination.currentPage && page >= 1 && page <= this.totalPages) {
        this.pagination.currentPage = page;
        this.fetchToolData();
      }
    },
    nextPage() {
      if (this.pagination.currentPage < this.totalPages) {
        this.changePage(this.pagination.currentPage + 1);
      }
    },
    prevPage() {
      if (this.pagination.currentPage > 1) {
        this.changePage(this.pagination.currentPage - 1);
      }
    },
    cancel()
    {
      this.$emit('close');
    },
    fetchToolData()
    {
      let getToolsUrl = `/Tool?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&notInToolGroup=true&toolStatusId=1&excludeMultiTool=true`
      if(this.searchQuery !== '')
      {
        getToolsUrl += `&searchString=${this.searchQuery}`
      }

      api.get(getToolsUrl)
      .then(response => {
        this.pagination.total = response.data.totalItems;
        this.tools = response.data.result.map(item => {
          return {
            id: item.id,
            name: `#${item.customerToolId} ${item.name}`,
            description: item.description,
            brandName: item.brandName,
            image: item.toolImageThumbnailBytes
          };
        });
      })
      .catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 })
      });
    },
    async addTool(toolId) {
      try {
        await api.put('/ToolGroup/AddTool', {
          toolGroupId: this.toolGroupId,
          toolId: toolId
        });
        this.$toast.success(this.$t('cars.toolAdded'), { timeout: 1500 });
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
      }
      this.fetchToolData();
      this.$emit('refresh-data');
    }
  },
};
</script>
<style>
.add-tool-icon {
  color: green;
  font-size: 24px;
  cursor: pointer;
  transition: transform 0.15s ease;
}
.add-tool-icon:hover {
  transform: scale(1.2);
}
</style>